export default __webpack_public_path__ + "static/media/D_Lunch.ee63c517.svg";